<template>
  <div class="c-list__content">
    <h2 class="c-list__title">
      <a
        v-bind:href="item.url" 
        class="c-list__link">
        {{item.title}}
        <svg class="c-list__file-icon" focusable="false" aria-hidden="true">
          <use v-bind="{ 'xlink:href': `#${item.extension}` }" />
        </svg>
        <span class="visually-hidden">{{item.extension}}</span>
      </a>
    </h2>
    <dl class="c-list__meta">
      <dt class="c-list__meta-title">Size</dt>
      <dd class="c-list__meta-detail">{{item.size}}</dd>
      <dt class="c-list__meta-title">Modified</dt>
      <dd class="c-list__meta-detail"><time v-bind:datetime="item.dateTime">{{item.dateTime | formatDate}}</time></dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "SearchItemDoc",
  props: {
    item: {
      type: Object
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/geneco/results/SearchItemDoc.vue